<template>
  <div v-if="content.provider" class="ReviewRating">
    <h2 v-if="content.heading" class="heading">{{ content.heading }}</h2>
    <div class="ratingContainer">
      <span v-html="logoGoogleSvg" class="logo" />
      <div class="starContainer">
        <span v-for="(star, index) in displayStars" :key="index" v-html="star" class="star" />
      </div>
      <div class="rating">{{ ratingProviderScore }}</div>
    </div>
  </div>
</template>

<script>
import ratings from './ratings.json'

import logoGoogleSvg from './images/logo-google.svg?raw'
import starEmptySvg from './images/star-rating-empty.svg?raw'
import starFullSvg from './images/star-rating-full.svg?raw'
import starOneQuarterSvg from './images/star-rating-one-quarter.svg?raw'
import starHalfSvg from './images/star-rating-half.svg?raw'
import starThreeQuarterSvg from './images/star-rating-three-quarters.svg?raw'

export default {
  props: {
    content: Object,
  },
  computed: {
    displayStars() {
      const maxStars = 5
      let remainingScore = this.ratingProviderScore
      const stars = [];

      for (let i = 0; i < maxStars; i++) {
        let star = starEmptySvg;

        if (remainingScore >= 1) {
          star = starFullSvg
        } else if (remainingScore >= 0.75) {
          star = starThreeQuarterSvg
        } else if (remainingScore >= 0.5) {
          star = starHalfSvg
        } else if (remainingScore > 0) {
          star = starOneQuarterSvg
        }

        stars.push(star)
        remainingScore -= 1
      }

      return stars
    },
    ratingProviderScore() {
      return ratings[this.content.provider]
    },
  },
  data() {
    return {
      logoGoogleSvg,
    }
  },
}
</script>

<style scoped>
.ReviewRating {
  color: var(--text-color-dark);
}
.heading {
  font-size: var(--font-size-1);
  text-align: center;
  margin-bottom: var(--spacing-1);
}

.ratingContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo:deep(svg) {
  width: 72px;
  height: auto;
}

.starContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: var(--spacing-7);
}
.starContainer > * + * {
  margin-left: var(--spacing-1);
}
.star:deep(svg) {
  width: 24px;
  height: auto;
}

.rating {
  background-color: var(--bg-color-dark-blue);
  border-radius: 6px;
  color: var(--text-color-white);
  display: flex;
  font-size: var(--font-size-1);
  font-weight: 600;
  justify-content: center;
  align-items: center;
  padding: 0.375rem var(--spacing-3);
  margin-left: var(--spacing-7);
}

@media (--screen-md) {
  .ReviewRating {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .heading {
    text-align: left;
    margin-bottom: 0;
  }
  .logo {
    margin-left: var(--spacing-7);
  }
  .logo:deep(svg) {
    width: 92px;
  }
  .star:deep(svg) {
    width: 32px;
  }
  .rating {
    border-radius: 9px;
    font-size: var(--font-size-0);
    padding: var(--spacing-1) var(--spacing-4);
  }
}
</style>
